import React, { Fragment } from "react";
import Header from "../layout/header";
import "./articleDetails.css";
import "../home/home.css";
import { CardBody } from "reactstrap";
import fetchApi from "../../common/fetchApi";
import axios from "axios";
import api from "../../routes/api";
import { format } from "timeago.js";
import Avatar from "react-avatar";
import toast, { Toaster } from "react-hot-toast";
import { millify } from "millify";
import { Card, IconButton } from "@mui/material";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  TumblrShareButton,
  VKShareButton,
  PinterestShareButton,
  RedditShareButton,
} from "react-share";
import {
  FacebookIcon,
  FacebookMessengerIcon,
  LinkedinIcon,
  TwitterIcon,
  PinterestIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  VKIcon,
  TelegramIcon,
} from "react-share";
import ArticleSchema from "./articleSchema";

import { Helmet } from "react-helmet";

import { useParams, useNavigate } from "react-router-dom";

function withParams(Component) {
  return (props) => (
    <Component {...props} params={useParams()} navigate={useNavigate()} />
  );
}

class ArticleDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {},
      likes: [],
      error: false,
      currentUserId: "",
    };
  }

  check;
  componentDidMount() {
    this.getArticleById();
    const script = document.createElement("script");
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5121538459968588";

    script.async = true;
    script.crossorigin = "anonymous";
    script.defer = true;
    document.body.appendChild(script);
  }

  getArticleById = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.setState({ currentUserId: user.data.data.id });
    }
    const { articleId } = this.props.params;

    const result = await axios({
      url: api.fetchArticleById,
      method: "POST",
      data: {
        id: articleId,
        userId:
          user && user !== null && user !== undefined ? user.data.data.id : "",
      },
    });
    console.clear();
    console.log(result);
    console.log(result.data.data, "<====data");
    if (result && result.data && result.data.success) {
      this.setState({ error: false, article: result.data.data });
    } else {
      this.setState({
        error: true,
        article: {
          title: "",
          firstname: "",
          lastname: "",
          createdAt: "",
          image: [],
          likes: [],
          desc: "",
          cat_name: "",
        },
      });
    }
  };

  // On Article Like
  likeArticle = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      url: api.likeArticle + `/${user.data.data.id}/${id}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      toast.success(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
      this.getArticleById();
    } else {
      toast.error(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    }
  };

  // On Article UnLike
  unlikeArticle = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      url: api.unlikeArticle + `/${user.data.data.id}/${id}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      toast.success(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
      this.getArticleById();
    } else {
      toast.error(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    }
  };

  checkUserId = async (likes) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if ((Array.isArray(likes) && likes.length) != 0) {
      likes.forEach((element) => {
        console.log(element);
        if (element.userId == user.data.data.id) {
          console.log(true);
          return true;
        } else {
          return false;
        }
      });
    } else {
      return false;
    }
  };

  //Add to cart
  addToCart = async (productId) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      return this.props.history.push("/login");
    }
    const userId = user.data.data.id;
    const token = user.data.token;
    const result = await axios({
      url: api.addToAdCart,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        userId,
        productId,
        market: "articles",
      },
    }).catch((err) => console.log(err));
    console.log(result);
    if (result && result.data && result.data.success) {
      //this.getDetails(setState, id);
      this.props.history.push("/adcart");
    } else if (result.data.message === "Item already added") {
      this.props.history.push("/adcart");
    }
  };
  slugify = (str) => {
    if (str) {
      return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
  };

  unslugify = (str) => str.replace("-", " ").toUpperCase().trim();

  render() {
    this.checkUserId(this.state.article.likes).then((data) => {
      this.check = data;
    });

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.state.article.title}</title>
          <meta name="description" content={this.state.article.title} />
        </Helmet>
        <Header />{" "}
        <ArticleSchema article={this.state.article} id={this.props.params} />
        <div className="row main-containt-box mx-0">
          <div className="chat-left-box">
            <div className="bg-white p-3">Advertisements</div>
          </div>
          <div className="chat-main-box">
            {this.state.error ? (
              <div
                style={{ fontSize: "2em" }}
                className="text-dark text-center mt-4"
              >
                Error: No Details Found
              </div>
            ) : (
              <div className="row justify-content-center">
                <div className="col-md-12 col-sm-12">
                  <Card style={{ borderRadius: "12px" }}>
                    <CardBody>
                      {/*style={{ objectFit: "contain" }}*/}
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="article-box big-box position-relative mb-4 p-0">
                            {this.state.article.image === "" ? (
                              <div></div>
                            ) : (
                              <img
                                className="a-width a-height object-fit"
                                src={this.state.article.image}
                              />
                            )}
                          </div>
                          <div className="mb-0 mt-3 w-100">
                            <div className="text-dark font-weight-bold text-start text-capitalize poppins">
                              <h1>{this.state.article.title}</h1>
                            </div>
                            <div className="d-flex mt-2">
                              <div
                                className="text-start text-capitalize poppins"
                                style={{ fontSize: "14px", color: "#666" }}
                              >
                                {this.state.article.cat_name}
                              </div>
                            </div>
                            <div className="d-flex mt-4 align-items-center">
                              <div className="mr-2">
                                {this.state.article.userImage === "" ? (
                                  <Link
                                    to={`/user-profile/${this.state.article.userId}`}
                                  >
                                    <Avatar
                                      className=""
                                      round={true}
                                      size="50"
                                      maxInitials={2}
                                      name={this.state.article.name}
                                    />
                                  </Link>
                                ) : (
                                  <Link
                                    to={`/user-profile/${this.state.article.userId}`}
                                  >
                                    <Avatar
                                      className=""
                                      round={true}
                                      size="50"
                                      maxInitials={2}
                                      src={this.state.article.userImage}
                                    />
                                  </Link>
                                )}
                              </div>
                              <div
                                className="text-start text-capitalize poppins"
                                style={{ fontSize: "14px" }}
                              >
                                <Link
                                  to={`/user-profile/${this.state.article.userId}`}
                                >
                                  {this.state.article.name}
                                </Link>
                              </div>
                              {/*{this.state.article.userId ===
                                this.state.currentUserId && (
                                <button
                                  type="button"
                                  className="btn btn-primary rounded ml-auto"
                                  disabled={this.state.isCart}
                                  onClick={() =>
                                    this.addToCart(this.state.article._id)
                                  }
                                >
                                  Sponsor Article
                                </button>
                                )} */}
                              {this.state.article.userId ===
                                this.state.currentUserId && (
                                <button
                                  type="button"
                                  className="btn btn-primary rounded ml-auto"
                                  disabled={this.state.isCart}
                                  onClick={() => this.props.navigate(`/tips`)}
                                >
                                  Do-follow Guideline
                                </button>
                              )}
                              <div
                                className="text-start text-capitalize ml-auto poppins"
                                style={{ fontSize: "14px" }}
                              >
                                {format(this.state.article.createdAt)}
                              </div>
                            </div>
                            <div
                              className="mt-2"
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  this.state.article.desc
                                ).replace(/\n/g, "<br>"),
                              }}
                            />
                            {!this.props.public && (
                              <div className="d-flex justify-content-center">
                                <div className="shadow rounded d-flex align-items-center mx-content">
                                  <div className="py-3 pl-3 pr-2">
                                    <IconButton
                                      disabled={this.state.article.isLike}
                                      style={{
                                        color: this.state.article.isLike
                                          ? "#47A600"
                                          : "#89e346",
                                      }}
                                      onClick={() => {
                                        this.likeArticle(
                                          this.state.article._id
                                        );
                                      }}
                                    >
                                      <FaThumbsUp />
                                    </IconButton>
                                  </div>

                                  <div className="py-3 pl-3 pr-2">
                                    {this.state.article.likeCount}
                                  </div>
                                  {/* <button className="btn btn-sm" 
                                                   disabled={this.state.article.isLike === false}
                                                    onClick={() => {this.unlikeArticle(this.state.article._id)}}
                                                    > */}
                                  <div className="py-3 pr-3 pl-2">
                                    <IconButton
                                      onClick={() => {
                                        this.unlikeArticle(
                                          this.state.article._id
                                        );
                                      }}
                                      disabled={
                                        this.state.article.isLike === false
                                      }
                                      style={{
                                        color: this.state.article.isLike
                                          ? "#e65353"
                                          : "#FF1616",
                                      }}
                                    >
                                      <FaThumbsDown />
                                    </IconButton>

                                    {/* <i className={this.state.article.isLike === false ? "fa fa-thumbs-down text-warning" :"fa fa-thumbs-down text-danger"}  ></i> */}
                                  </div>
                                  {/* </button> */}
                                </div>
                              </div>
                            )}
                            <div style={{ marginTop: "10px" }}>
                              <TwitterShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <TwitterIcon size={32} round={true} />
                              </TwitterShareButton>
                              <FacebookShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <FacebookIcon size={32} round={true} />
                              </FacebookShareButton>
                              <RedditShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <RedditIcon size={32} round={true} />
                              </RedditShareButton>
                              <WhatsappShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <WhatsappIcon size={32} round={true} />
                              </WhatsappShareButton>
                              <LinkedinShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <LinkedinIcon size={32} round={true} />
                              </LinkedinShareButton>
                              <TelegramShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <TelegramIcon size={32} round={true} />
                              </TelegramShareButton>
                              <VKShareButton
                                url={`${window.location.origin}/article-details/${this.state.article._id}`}
                              >
                                <VKIcon size={32} round={true} />
                              </VKShareButton>
                            </div>
                            <div>
                              <a
                                className="pull-right text-start poppins"
                                style={{ fontSize: "10px" }}
                                href={`https://fonolive.com/search/articles/detail/${this.state.article._id}`}
                              >
                                SEO Link
                              </a>
                            </div>
                            <h2>{this.state.article.title}</h2>
                            <div>
                              <a
                                className="pull-right text-start poppins"
                                style={{ fontSize: "10px" }}
                                href={`https://fonolive.com/articles/query/${this.slugify(
                                  this.state.article.title
                                )}`}
                              >
                                More : {this.state.article.title}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
          </div>
        </div>
        <Toaster />
      </>
    );
  }
}
export default withParams(ArticleDetails);
